







import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class PartCatalogCardBracketsList extends Vue {
  // Props
  @Prop({ type: String, default: 'lowercase', validator: value => [false, 'lowercase', 'uppercase'].some(value => !!value)})
  transform: string;

  @Prop({ type: Array, default: () => [], })
  list: Array<string>;

  // computed
  get visible() {
    return this.list && this.list.length > 0;
  }

  get joined() {
    return this.list.join(', ');
  }

  get classes() {
    const result = [];
    const { transform } = this;
    if (transform) result.push(`transform-${transform}`);
    return result;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/sidebar/components/BracketsList.vue